import { Button } from '../../../../components/buttons'
import { colorPalette } from '../../../../style/colorPalette'
import ReloadIcon from '../../../../components/icons/ReloadIcon'
import AddRoundedIcon from '@mui/icons-material/AddRounded'
import GetAppRoundedIcon from '@mui/icons-material/GetAppRounded'
import CircularProgress from '@mui/material/CircularProgress'
import { intl } from '../../../../../i18n'
import { featureFlagService } from '../../../../../utils/feature-flag'
import { useDownloadOpenApiDocs } from '../../../../hooks/useDownloadOpenApiDocs'

type Props = {
  loading: boolean
  functionUuid: string
  onReload: () => void
  onClickCreateToken: () => void
}

const ApiTokenManagementHeader = ({
  loading,
  functionUuid,
  onReload,
  onClickCreateToken,
}: Props) => {
  const { handleDownload, isDownloading } = useDownloadOpenApiDocs(functionUuid)

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        margin: '10px 10px 5px 10px',
        overflowX: 'auto',
        overflowY: 'hidden',
        minHeight: '47px',
      }}
    >
      <Button
        onClick={onReload}
        disabled={loading}
        sx={{
          background: colorPalette.monotone[1],
          border: `1px solid ${colorPalette.monotone[3]}`,
          borderRadius: '50%',
          height: '28px',
          width: '28px',
          marginRight: '10px',
          padding: '5px 8px',
          cursor: 'pointer',
          '&:hover': { background: colorPalette.monotone[1] },
        }}
      >
        <ReloadIcon />
      </Button>
      <Button
        variant="filled"
        colorPattern="skyBlue"
        size="m"
        onClick={onClickCreateToken}
        disabled={loading}
      >
        <AddRoundedIcon fontSize="small" />
        {intl.formatMessage({
          id: 'apiTokenManagement.createServiceTokenButton',
        })}
      </Button>
      {featureFlagService.isEnabled('openapi-docs-download') && (
        <Button
          variant="outlined"
          colorPattern="monotone"
          size="m"
          onClick={handleDownload}
          disabled={isDownloading}
          sx={{ marginLeft: '16px' }}
        >
          {isDownloading ? (
            <CircularProgress size={16} color="inherit" />
          ) : (
            <GetAppRoundedIcon fontSize="small" />
          )}
          {intl.formatMessage({
            id: 'openApiDocs.download',
          })}
        </Button>
      )}
      <div style={{ flex: 1 }} />
    </div>
  )
}

export default ApiTokenManagementHeader
